import {Utilities} from '@shared/utilities/utilities.model';
import {ListModel} from '@shared/models/list.model';
import {UserV3Model} from '@shared/models/user-v-3.model';

export class UsersListModel extends ListModel {

	constructor(model?: any) {
		super(model);
		this.items = [];
		if (!Utilities.isVoid(model) && !Utilities.isVoid(model.items)) {
			model.items.forEach((item) => this.items.push(new UserV3Model(item)));
		}
	}
}
